import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { COMMUNITY_DETAIL_TABS } from '../../constants';
import createOnboardingTemplateService from '../../services/onboardingTemplates/createOnboardingTemplateService';
import OnboardingTemplateForm from './OnboardingTemplateForm';
import { mapFormToOnboardingTemplate } from '../../helpers/mapFormToOnboardingTemplate';

const EMPTY_ONBOARDING_TEMPLATE = { name: '' };

const NewOnboardingTemplate = ({
  open,
  dispatchCreateOnboardingTemplatePost,
  createOnboardingTemplateFetch,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const handleSubmit = useCallback(
    body => {
      dispatchCreateOnboardingTemplatePost(
        mapFormToOnboardingTemplate(body, id),
        () => navigate(`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.ONBOARDING_TEMPLATES}`),
        t
      );
    },
    [id, dispatchCreateOnboardingTemplatePost, t, navigate]
  );

  if (!open) return null;

  return (
    <OnboardingTemplateForm
      header={t('newOnboardingTemplate')}
      onSubmit={handleSubmit}
      submitProcessing={createOnboardingTemplateFetch.pending}
      returnRoute={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.ONBOARDING_TEMPLATES}`}
      cancelRoute={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.ONBOARDING_TEMPLATES}`}
      data={EMPTY_ONBOARDING_TEMPLATE}
    />
  );
};

NewOnboardingTemplate.propTypes = {
  dispatchCreateOnboardingTemplatePost: PropTypes.func.isRequired,
  createOnboardingTemplateFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

NewOnboardingTemplate.defaultProps = { open: false };

export default createOnboardingTemplateService(NewOnboardingTemplate);
